
/**
 * Internal dependencies
 */
import './widgets/godam-video.js';
import './widgets/godam-gallery.js';
